import { loadStripe } from '@stripe/stripe-js/pure'
import type { Stripe } from '@stripe/stripe-js'

export default function useStripe() {
  const { $sitewideConfig } = useNuxtApp()

  const stripeInstance = useState<Stripe | null>('stripeInstance', () => shallowRef(null))

  async function load() {
    if (!stripeInstance.value) {
      try {
        stripeInstance.value = await loadStripe($sitewideConfig.config.stripeKey)
      } catch (error) {
        console.error('Stripe Load Error', { error })
      }
    }

    return stripeInstance.value
  }

  return {
    load,
  }
}
